<!--<div>
  <div class="msc-banner">
    <div class="msc-banner__gradient">
      <div [ngStyle]="{ 'background-image': 'url(' + background + ')' }"></div>
    </div>
  </div>
  <header>
    <div class="flex justify-between mb-8 md--flex-row">
      <div class="breadcrumb-v2 overflow-hidden pl-4">
        <h3 class="breadcrumb-v2--back whitespace-nowrap" (click)="navigate()">
          {{
          (isFromSubscriptions
          ? "words.my-training-courses"
          : "words.catalogue"
          ) | translate
          }}
        </h3>
        <i class="icon icon-arrow-ios-right"></i>
        <h3 class="truncate">{{ title }}</h3>
      </div>

      <div class="flex gap-4 md--flex-row">
        <msc-button class="msc-button--secondary msc-button--tiny" icon="icon-link-1" (click)="clipboard()">
          {{ "words.share-link" | translate }}
        </msc-button>
        <msc-button class="msc-button--secondary msc-button--tiny" palette="primary"
          [icon]="saved ? 'icon-bookmark-1' : 'icon-bookmark'" (click)="changeLearnLaterContent()">
          {{ "words.bookmark" | translate }}
        </msc-button>
        <msc-button *ngIf="context !== 'external-content' && account" class="msc-button--primary msc-button--tiny"
          palette="secondary" (click)="openConversation()">
          {{ 'words.contact-creator' | translate }}
        </msc-button>
        <msc-button class="msc-button--primary msc-button--tiny" palette="danger" *ngIf="isVisibleSubscriptionMenu"
          (click)="modalDelete.open(title)">
          {{ "words.unsubscribe" | translate }}
        </msc-button>
      </div>
    </div>
    <msc-common-tab [navigation]="navigation"> </msc-common-tab>
  </header>
</div>-->

<!--Details course base -->
<router-outlet></router-outlet>

<msc-card-manager-modal-delete-subscription #modalDelete [type]="context" (onSave)="deleteContent($event)">
</msc-card-manager-modal-delete-subscription>

<ng-container>
  <!--br Mostrar solo si no hay comentarios -->
  <div class="hidden" *ngIf="!ratingComments || ratingComments.length === 0">
    <div class="grid grid-cols-3 gap-x-20 gap-y-8 mx-auto max-w-7xl my-8">
      <div class="col-span-3 flex justify-end w-full" style="height: 13rem;">
      </div>
    </div>
  </div>


  <div class="grid grid-cols-3 gap-x-20 gap-y-8 mx-auto max-w-7xl ">
    <div class="col-span-2">
      <!-- raking -->
      <div class="relative py-4">

        <div class="col-span-2 relative" *ngIf="ratingComments?.length > 0">
          <h2 class="text-xl font-semibold">{{ 'words.comment' | translate }}</h2>
          <!-- Slider Container -->
          <div #sliderComments class="flex items-start overflow-x-auto scrollbar-hide space-x-4 snap-x snap-mandatory pt-6 pb-8 gap-2">
            <!-- Card 1 -->

            <div class="flex-shrink-0
                w-[calc(100%-1rem)]       
                sm:w-[calc(50%-2rem)]    
                md:w-[calc(33.333%-1rem)]
                lg:w-[calc(33.333%-1rem)]     
                xl:w-[calc(33.333%-1rem)]    
                2xl:w-[calc(33.333%-1rem)] " *ngFor="let comment of ratingComments">
              <div
                class="bg-white rounded-lg p-5 flex flex-col justify-between hover:shadow-xl transition-all duration-200 ease-in-ou border border-gray-100 min-h-[12rem] h-auto"
                style="box-shadow: 0 4px 8px 3px #0000000a;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);">
                <div>
                  <div class="flex text-yellow-400 mb-2 gap-1">
                    <ng-container *ngFor="let star of getStars(comment.rating)">
                      <i class="fas fa-star"></i>
                    </ng-container>
                  </div>
                  <p class="italic text-sm leading-relaxed text-gray-600 mt-1 break-words" [ngClass]="{'line-clamp-3': !comment.expanded}">{{comment.comment}}</p>
                  <button type="button" *ngIf="comment.comment?.length > 120"
                    (click)="comment.expanded = !comment.expanded"
                    class="mt-2 inline-flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700">
                    <span>{{ (comment.expanded ? 'words.see-less' : 'words.see-more') | translate }}</span>
                    <i class="icon text-[10px]" [ngClass]="comment.expanded ? 'icon-chevron-up' : 'icon-chevron-down'"></i>
                  </button>
                </div>
                <div class="flex items-center gap-3 mt-3 pt-3 border-t border-gray-100 min-w-0"><img
                   [src]="comment.picture ? comment.picture + '?size=512' : 'https://static.vecteezy.com/system/resources/previews/000/701/690/non_2x/abstract-polygonal-banner-background-vector.jpg'"
                    class="w-8 h-8 rounded-full object-cover shrink-0" />
                  <div class="min-w-0">
                    <p class="text-xs font-semibold text-gray-700 break-words">{{comment.fullname}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Flechas de navegación -->
          <button *ngIf="ratingComments.length > 3" (click)="scrollLeft()"
            class="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-gray-50 rounded-full shadow-lg hover:shadow-xl transition-shadow flex items-center justify-center">
            <i class="fas fa-chevron-left text-gray-600"></i>
          </button>

          <button *ngIf="ratingComments.length > 3" (click)="scrollRight()"
            class="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-gray-50 rounded-full shadow-lg hover:shadow-xl transition-shadow flex items-center justify-center">
            <i class="fas fa-chevron-right text-gray-600"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Slider y Footer (sin cambios) -->

  <app-owl-carousel [title]="'words.recently-view' | translate" [contents]="carouselItems" [zIndex]="100"
    [origin]="'subscribed'">
  </app-owl-carousel>

</ng-container>